import React from "react"
import { Spinner } from "react-bootstrap"
import { formatDateForDisplay } from "../../utils/dateUtils"

const InspectionHistoryView = ({ history = [], loading = false }) => {
    // Sort history items in reverse chronological order
    const sortedHistory = [...history].sort((a, b) => {
        const dateA = new Date(a.DateTimeStamp);
        const dateB = new Date(b.DateTimeStamp);
        return dateB - dateA;
    });

    return (
        <div className="h-100 d-flex flex-column">
            <div className="p-3 border-bottom">
                <h6 className="mb-0">
                    <i className="fas fa-history me-2" />
                    Ιστορικό
                </h6>
            </div>
            <div className="flex-grow-1 overflow-auto">
                {loading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" size="sm" className="text-muted" />
                        <div className="text-muted mt-2">Φόρτωση ιστορικού...</div>
                    </div>
                ) : sortedHistory.length > 0 ? (
                    <div className="calendar-accordion">
                        {sortedHistory.map(item => (
                            <div key={item.ID} className="nav-link mb-2">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <small className="text-muted">
                                        {formatDateForDisplay(item.DateTimeStamp)}
                                    </small>
                                    <small className="text-muted">
                                        <i className="fas fa-user me-0" />
                                        {item.UserID}
                                    </small>
                                </div>
                                <div style={{ fontSize: '0.875rem' }}>{item.Descr}</div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-4 text-muted">
                        <i className="fas fa-info-circle me-2" />
                        Δεν υπάρχει διαθέσιμο ιστορικό
                    </div>
                )}
            </div>
        </div>
    )
}

export default InspectionHistoryView 